import React, {useState} from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";

const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'white',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px',
    width: '600px',
    padding: "40px",
};

export const NewColumnModal = ( {isOpen, setIsOpen, onSave, columns} ) => {
    const [name, setName] = useState('')

    return (
        <Modal
            open={isOpen}
            onClose={() => setIsOpen(null)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                style={{
                    ...style,
                }}
            >
                <Stack
                    direction="column"
                    justifyContent="space-between"
                    alignItems="left"
                    className={''}
                >
                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                    >
                        Create New Column
                    </Typography>
                    <Divider className={'divider'} sx={{ marginBottom: '10px'}}/>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{
                            padding: "10px 0"
                        }}
                    >
                        <label>Name: </label>
                        <input
                            style={{
                                border: "1px solid rgba(0, 0, 0, 0.12)",
                                borderRadius: "10px",
                                padding: "7px 10px",
                                width: '100%',
                                marginLeft: "10px",
                            }}
                            type="text"
                            value={name}
                            autoFocus={true}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Stack>

                    <Divider className={'divider'} sx={{ margin: '10px'}}/>

                    <Button
                        style={{
                            alignSelf: 'end'
                        }}
                        onClick={() => {
                            onSave(name)
                            setIsOpen(false)
                        }}
                        disabled={!name}
                    >
                        Create
                    </Button>

                </Stack>
            </Box>
        </Modal>
    )
}